import cx from 'classnames'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { useSearchParams } from 'react-router-dom'

import {
  Link,
  matchI18nPath,
  matchI18nPathList,
  useMatch,
} from 'features/i18n/router'
import { useGroupOrThreadOrPostPageData } from 'hooks'
import { logEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'
import { selectIsLoggedIn } from 'store/selectors'

const GroupNav = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const isLoggedIn = useSelector(selectIsLoggedIn)

  const { groupId, groupRes } = useGroupOrThreadOrPostPageData()
  const isGroupDetailPage = Boolean(useMatch(ROUTE_PATH.GROUP_DETAIL()))

  const menu = [
    {
      label: t('common.posts'),
      to: ROUTE_PATH.GROUP(groupId),
      key: 'post',
      match: [
        ROUTE_PATH.GROUP(),
        ROUTE_PATH.GROUP_ALBUM(),
        ROUTE_PATH.GROUP_POST(),
        ROUTE_PATH.GROUP_POST_REPOST(),
        ROUTE_PATH.GROUP_CONVERSATION(),
      ],
    },
    {
      label: t('common.thread'),
      to: ROUTE_PATH.GROUP_THREADS(groupId),
      key: 'thread',
      withBadge: groupRes?.data?.unread_threads_count > 0,
      matchStart: true,
    },
    {
      label: t('common.highlight'),
      to: ROUTE_PATH.GROUP_HIGHLIGHTS(groupId),
      key: 'highlight',
    },
    {
      label: t('group_tab.info'),
      to: ROUTE_PATH.GROUP_INFORMATION(groupId),
      key: 'info',
      matchStart: true,
    },
  ]

  useEffect(() => {
    if (!groupRes?.isUninitialized) {
      // For updating `unread_threads_count`.
      groupRes.refetch()
    }
  }, [location.pathname])

  if (!isLoggedIn || groupRes?.isLoading || isGroupDetailPage) {
    return null
  }

  const forceActive = searchParams.get('h')

  return (
    <div className="Group__nav">
      {menu.map((i) => (
        <Link
          key={i.label}
          to={i.to}
          className={cx('Group__nav__a', {
            'Group__nav__a--active': Boolean(
              forceActive
                ? forceActive === i.key
                : matchI18nPathList(i.match ? i.match : [i.to], {
                    startsWith: i.matchStart,
                  })
            ),
          })}
          onClick={() => {
            logEvent.group_tab_change({
              from_tab: menu?.find?.((x) => Boolean(matchI18nPath(x?.to)))?.key,
              to_tab: i?.key,
            })
          }}
        >
          <span
            className={cx('Group__nav__a__span', {
              'Group__nav__a__span--with-badge': i.withBadge,
            })}
          >
            {i.label}
          </span>
        </Link>
      ))}
    </div>
  )
}

export default GroupNav
